import React from 'react';
import { IoMdArrowDropdown } from "react-icons/io";
import { FaArrowCircleLeft } from "react-icons/fa";
import { FaArrowCircleRight } from "react-icons/fa";
import { MdUnfoldMore } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom"; // Added useNavigate here
import Header from '../../../header/header';
import Navvbar from '../../../header/Navvbar';
import Footer from '../../../footer';

const NewAccountDefaults = () => {
  const navigate = useNavigate(); // Added this hook for navigation

  return (
    <>
      {/* Header and Navbar */}
      <div style={{ marginBottom: "25px" }}>
        <Header />
        <Navvbar />
      </div>

      {/* Main Layout: Sidebar + Content */}
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          
          {/* LEFT SIDEBAR - Copied from CaseSetting.js */}
          <div className="col-md-2" style={{ borderRight: "1px solid #004aad" }}>
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textfDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                      fontWeight: "bold", // Highlight current page
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT - Your NewAccountDefaults */}
          <div className="col-md-10">
            <h1 >New Account Defaults</h1>

            {/* Top Controls */}
            <div style={{ borderTop: '2px solid #004aad', padding: '10px', backgroundColor: '#f5f5f5', position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <span style={{ marginRight: '5px', color: '#333' }}>Search:</span>
                    <input
                      type="text"
                      style={{ padding: '5px', width: '150px', border: '1px solid #ccc', borderRadius: '4px', marginRight: '10px' }}
                    />
                  </div>
                   <div style={{ color: '#333', fontSize: '14px' }}>
                Showing 0 to 0 of 0 entries
              </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', color: '#333' }}>Rule</span>
                    <span style={{ marginLeft: '300px', display: 'flex', alignItems: 'center', color: '#333' }}>
                      <IoMdArrowDropdown />
                      Procedure Group
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <MdUnfoldMore />
                      </span>
                    </span>
                  </div>
                </div>
                <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <button
                    style={{
                      backgroundColor: '#004aad',
                      color: 'white',
                      padding: '5px 10px',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                    }}
                    onClick={() => navigate('/add-account-default')} // Added onClick for navigation
                  >
                    + Add
                  </button>
                  <div style={{ display: 'flex', marginTop: '5px' }}>
                    <FaArrowCircleLeft style={{ marginRight: '5px', fontSize: '14px', color: '#333' }} />
                    <FaArrowCircleRight style={{ fontSize: '14px', color: '#333' }} />
                  </div>
                </div>
              </div>
            </div>

            {/* No Data Message */}
            <div style={{
              textAlign: 'center',
              color: '#333',
              fontSize: '14px',
              paddingTop: '20px',
              paddingBottom: '20px',
            }}>
              No data available in table
            </div>

            {/* Footer with Pagination */}
            <div style={{
              borderTop: '2px solid #004aad',
              padding: '10px',
              backgroundColor: '#f5f5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
              <div style={{ color: '#333', fontSize: '14px' }}>
                Showing 0 to 0 of 0 entries
              </div>
              <div style={{ display: 'flex' }}>
                <FaArrowCircleLeft style={{ marginRight: '5px', fontSize: '14px', color: '#333' }} />
                <FaArrowCircleRight style={{ fontSize: '14px', color: '#333' }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer at Bottom */}
      <div style={{ width: "95%", margin: "0 auto", padding: "0px", marginTop: "50px" }}>
        <Footer />
      </div>
    </>
  );
};

export default NewAccountDefaults;